import { NgModule } from '@angular/core';
import { AuthModule } from '@freelancer/auth';
import { UiModule } from '@freelancer/ui';
import { ModalModule } from '@freelancer/ui/modal';
import { CompatModalsComponent } from './compat-modals.component';

@NgModule({
  imports: [AuthModule, UiModule, ModalModule],
  declarations: [CompatModalsComponent],
  entryComponents: [CompatModalsComponent],
})
export class CompatModalsModule {}
